module.exports = __webpack_public_path__ + "static/media/level-up.b6c6553d.svg";